import { useQuery } from '@tanstack/react-query';
import { useSelector } from 'react-redux';
import { get } from 'app/shared/utils/fetchr';
import { ActionMapping } from 'app/modules/bankingIntegrations/models';
import { BANKING_INTEGRATIONS_QUERY_KEYS } from 'app/modules/bankingIntegrations/queries/keys';
import { selectHasEditCoreBankingPermission } from 'app/modules/session/selectors';

export const useListActionMappings = () => {
  const hasEditCoreBankingPermission = useSelector(
    selectHasEditCoreBankingPermission,
  );

  return useQuery({
    enabled: hasEditCoreBankingPermission,
    queryKey: BANKING_INTEGRATIONS_QUERY_KEYS.getActionMappings(),
    queryFn: () => get<ActionMapping[]>('/v1/banking-integrations/mappings'),
    staleTime: Infinity,
  });
};
